export default [{
  path: 'labeling',
  name: 'workspace.labeling',
  meta: { title: '标注', icon: 'icon-pricetags-outline', 'permissions': [{ 'resource': 'Workspace', 'behaviors': ['read'] }] },
  component: () => import('@/views/Labeling')
}, {
  path: 'file',
  name: 'workspace.file',
  meta: { title: '文件', icon: 'icon-folder-outline' },
  component: () => import('@/views/File')
}, {
  path: 'model',
  name: 'workspace.model',
  meta: { title: '模型', icon: 'icon-layers-outline' },
  component: () => import('@/views/Blank')
}, {
  path: 'team',
  name: 'workspace.team',
  meta: { title: '组管理', icon: 'icon-people-outline' },
  component: () => import('@/views/Blank')
}, {
  path: 'task',
  name: 'workspace.task',
  meta: { title: '任务', icon: 'icon-checkmark-square-outline' },
  component: () => import('@/views/Blank')
}, {
  path: 'application',
  name: 'workspace.application',
  meta: { title: '应用', icon: 'icon-play-circle-outline' },
  component: () => import('@/views/Blank')
}, {
  path: 'monitor',
  name: 'workspace.monitor',
  meta: { title: '监控', icon: 'icon-activity-outline' },
  component: () => import('@/views/Blank')
}]
